// STAR CRETE custom interactions
document.addEventListener('DOMContentLoaded', function () {

// Scroll reveal
var faders = document.querySelectorAll('.sc-fade');
if ('IntersectionObserver' in window && faders.length) {
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) {
if (entry.isIntersecting) {
entry.target.classList.add('sc-in');
io.unobserve(entry.target);
}
});
}, { threshold: 0.15 });
faders.forEach(function (el) { io.observe(el); });
} else {
faders.forEach(function (el) { el.classList.add('sc-in'); });
}

// Back to top
var backTop = document.querySelector('.sc-back-top');
if (backTop) {
window.addEventListener('scroll', function () {
if (window.scrollY > 500) { backTop.classList.add('sc-show'); }
else { backTop.classList.remove('sc-show'); }
});
backTop.addEventListener('click', function () {
window.scrollTo({ top: 0, behavior: 'smooth' });
});
}

// Lightbox gallery
var galleryItems = document.querySelectorAll('[data-sc-lightbox-item]');
var lightbox = document.querySelector('[data-sc-lightbox]');
if (galleryItems.length && lightbox) {
var lbImg = lightbox.querySelector('img');
var current = 0;
var urls = Array.prototype.map.call(galleryItems, function (el) { return el.getAttribute('data-full'); });
function openLightbox(i) {
current = i;
lbImg.setAttribute('src', urls[current]);
lightbox.classList.add('sc-open');
}
galleryItems.forEach(function (el, i) {
el.addEventListener('click', function () { openLightbox(i); });
});
var closeBtn = lightbox.querySelector('[data-sc-lb-close]');
if (closeBtn) closeBtn.addEventListener('click', function () { lightbox.classList.remove('sc-open'); });
lightbox.addEventListener('click', function (e) { if (e.target === lightbox) lightbox.classList.remove('sc-open'); });
var prevBtn = lightbox.querySelector('[data-sc-lb-prev]');
var nextBtn = lightbox.querySelector('[data-sc-lb-next]');
if (prevBtn) prevBtn.addEventListener('click', function () { current = (current - 1 + urls.length) % urls.length; lbImg.setAttribute('src', urls[current]); });
if (nextBtn) nextBtn.addEventListener('click', function () { current = (current + 1) % urls.length; lbImg.setAttribute('src', urls[current]); });
document.addEventListener('keydown', function (e) {
if (!lightbox.classList.contains('sc-open')) return;
if (e.key === 'Escape') lightbox.classList.remove('sc-open');
if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
});
}

// Before / after slider
var baBlocks = document.querySelectorAll('[data-sc-ba]');
baBlocks.forEach(function (wrap) {
var handle = wrap.querySelector('.sc-ba__handle');
var beforeWrap = wrap.querySelector('.sc-ba__before-wrap');
var dragging = false;
function setPos(clientX) {
var rect = wrap.getBoundingClientRect();
var pct = ((clientX - rect.left) / rect.width) * 100;
pct = Math.max(0, Math.min(100, pct));
beforeWrap.style.width = pct + '%';
handle.style.left = pct + '%';
}
handle.addEventListener('mousedown', function (e) { dragging = true; e.preventDefault(); });
window.addEventListener('mouseup', function () { dragging = false; });
window.addEventListener('mousemove', function (e) { if (dragging) setPos(e.clientX); });
handle.addEventListener('touchstart', function () { dragging = true; }, { passive: true });
window.addEventListener('touchend', function () { dragging = false; });
window.addEventListener('touchmove', function (e) { if (dragging && e.touches[0]) setPos(e.touches[0].clientX); }, { passive: true });
wrap.addEventListener('click', function (e) { setPos(e.clientX); });
});

// Testimonial nav
var testiTrack = document.querySelector('[data-sc-testi-track]');
if (testiTrack) {
var prev = document.querySelector('[data-sc-testi-prev]');
var next = document.querySelector('[data-sc-testi-next]');
var scrollAmount = function () { return testiTrack.clientWidth * 0.86; };
if (prev) prev.addEventListener('click', function () { testiTrack.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
if (next) next.addEventListener('click', function () { testiTrack.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
}

});
